import { DateFormatter } from '@repo/toolkit/date'
import { toFullName } from '@repo/toolkit/to-full-name'

import { Tefl } from './tefl'

export class TeflProperties {
  /**
   *  Returns a label for the TEFL object.
   */
  static teflLabel = (tefl?: Tefl) => {
    if (!tefl) return ''
    return `${toFullName(tefl.firstName, tefl.lastName)} - ${tefl.gender} - ${tefl.birthDate ? DateFormatter.calculateAge(tefl.birthDate) : ''}`
  }
}
